import { RetailCartItem } from "@/dto/retailCartItem";
import { ScanToOrderCartItem } from "./scanToOrderCartItem/scanToOrderCartItem";

export interface CurrentItemsSectionProps {
  cartItems: RetailCartItem[];
  removeFromCart: (event: React.MouseEvent, index: number) => void;
  onRequestClose: () => void;
}

export const CurrentItemsSection = ({
  cartItems,
  removeFromCart,
  onRequestClose,
}: CurrentItemsSectionProps) => {
  return (
    <div className="pt-11 mx-4">
      {cartItems?.map((item: RetailCartItem, index: number) => (
        <ScanToOrderCartItem
          key={index}
          index={index}
          item={item.value}
          removeFromCart={removeFromCart}
          onRequestClose={onRequestClose}
        />
      ))}
    </div>
  );
};
